import { RedirectModal } from "../../../Fundraising.UI.Shared/Modules/redirectModal/RedirectModal";

export {
    RedirectModal
}
